import { useEffect } from 'react';

type UseKeyboardNavigationProps = {
  onEscape?: VoidFunction;
  onEnter?: VoidFunction;
  enabled?: boolean;
};

export const useKeyboardNavigation = ({
  onEscape,
  onEnter,
  enabled = true,
}: UseKeyboardNavigationProps) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      const isInputFocused =
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable;

      if (event.key === 'Escape' && onEscape) {
        event.preventDefault();
        onEscape();
      }

      if (event.key === 'Enter' && onEnter && !isInputFocused) {
        event.preventDefault();
        onEnter();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onEscape, onEnter, enabled]);
};
